export const siteConfig = {
  name: "Dit Liv Dit Ansvar",
  logo: "/materiale-260501/image00007.png",
  email: "Kontakt@ditlivditansvar.dk",
  phone: "26368306",
  address: "Kolding, Danmark",
  social: {
    facebook: "https://www.facebook.com/share/1Cu2oYAp3B/?mibextid=wwXIfr",
    linkedin: "http://linkedin.com/in/michael-lunde-8042b7202",
    instagram: "https://www.instagram.com/ditliv.ditansvar/"
  }
};

export const testimonials = [
  {
    id: 1,
    name: "Lone Henriksen",
    age: "54 år",
    text: "Jeg blev mobbet i skolen, og det har forfulgt mig hele mit liv. Michael hjalp mig til at forstå at det ikke var min skyld, og gav mig min selvtillid og mit selvværd igen. Han fik mig til at se at jeg er et godt menneske. Han er guld værd.",
    type: "klient"
  },
  {
    id: 2,
    name: "Lise",
    age: "39 år",
    text: "Jeg har været i et forløb med Michael. Det har givet mig rigtig meget. Da jeg startede ved Michael sov og spiste jeg ikke rigtig, nu er jeg begyndt at spise igen og sover nu det meste af natten, UDEN SOVEPILLER!",
    type: "klient"
  },
  {
    id: 3,
    name: "Pia",
    age: "56 år",
    text: "Michael Lunde er ikke blot menneskekender, men også en god sparringspartner. Han finder hurtigt ind til kernen, og den blokering der ligger i vejen for succes. For mit vedkomne ’gik der hul på bylden’ allerede efter 2 session, og der er nu lys forude.",
    type: "klient"
  },
  {
    id: 4,
    name: "Allan",
    age: "52 år",
    text: `"Angst æder sjæle op" er titlen på en film af Rainer Werner Fassbinder. Denne følelse har jeg gennem mange år haft, hvor jeg til tider har levet i et "angsthelvede".

Men ultimo 2016 valgte jeg at tage skeen i den anden hånd med henblik på lære at styre og arbejde med angsten frem for at den styrede mig.

Denne ændring har Michael hjulpet mig rigtig meget med, dette er sket gennem personlige samtaler, hvor vi har talt om hvad der sker med mig, når jeg rammes af angst, hvordan jeg kan modvirke konsekvenserne af angsten og hvordan jeg lærer at håndtere angsten når den kommer.

Jeg har lært en masse teknikker og værktøjer, som jeg bruger flittigt i dagligdagen, nogle af dem bruger jeg hele tiden og ikke kun i forbindelse med angstanfald.

Michael's måde til både at bidrage med input og værktøjer, samt udfordrer mig, til selv at forholde mig til angsten har været super god.

Vores samtaler har været rigtig gode og jeg har været tryg før, under og efter disse, men også til tider meget udfordret på den gode måde.`,
    type: "klient"
  },
  {
    id: 5,
    name: "Frederik",
    age: "43 år",
    text: "Jeg har prøvet andet hjælp tidligere, da jeg 2 gange før har været syg med stress. Da jeg så et af Michaels opslag hvor han nævnte det med at forstå kroppen, blev jeg nysgerrig. Det blev til et forløb på 4 sessioner, og dem skulle jeg ha startet med for mange år siden! Michael er meget passioneret og det smitter. Hans måde at være på blandet med professionel rådgivning og coaching, har gjort at jeg ikke kun lærte at forstå mit stress, men også lærte at takle den.",
    type: "klient"
  },
  {
    id: 6,
    name: "Dina",
    text: `Jeg har gået i et coaching forløb hos Michael Lunde og selvom jeg altid har gået meget op i min personlig udvikling og har en generelt interesse på området, så kan man altid lære noget nyt og brugbart om sig selv.

Nogle gange skal man høre tingene på en ny måde for, at det sætter sig fast og nogle gange skal der suppleres med ekstra viden.

Det jeg især tager med fra min coaching fra Michael er den viden han har om, hvordan kroppen kan blive påvirket biologisk af stress og traumer fra barndommen. Her fik jeg nogle ”aha-oplevelser”, som har givet en bevidsthed, som i sidste ende har givet mig brændsel til at tage handling på at ændre de mønstre, der har forfulgt mig hele livet og som er forsøgt ændret mange gange tidligere.

Jeg er faktisk også blevet provokeret under disse sessions og det har egentlig bare været godt for mig at blive provokeret lidt – fordi det netop har været med til rykke mig. Men provokeret fordi, Michaels måde at være coach på er meget anderledes end hvad jeg tidligere har prøvet. På mange måde er det mere en samtale, som man kan have med en god ven, hvor man hver især deler viden og oplevelser fra eget liv og ikke den traditionelle måde, hvor coachen primært stiller spørgsmål og man selv skal komme med svarene og jeg kan bedst lide, når man ”følger reglerne” — sagt med et smil, fordi jeg egentlig godt selv kan lide at gøre tingene på en anderledes måde.

Men som jeg ser det og tror det, så er Michael en god menneskekender og han har indirekte fået de budskaber ud, som var nødvendigt for den udvikling, som jeg har haft brug for. Hvis han bare havde gjort det, som jeg tidligere har prøvet, så havde jeg ikke reflekteret så meget over det, som jeg har gjort i dette forløb og jeg har bestemt fået det ud af det, som jeg kunne ønske. Det har betyder en langt større tro på mig selv og når jeg begynder at undskylde inde i hovedet, så bremser sig mig selv inden det kommer ud af munden og husker på, at lige præcis den måde jeg er på og de følelser jeg har er helt okay! For jeg skal jo bare være mig og så arbejder jeg også fortsat på, at vende de negative historier, som jeg har skabt om mig selv til noget positivt.`,
    type: "klient"
  },
  {
    id: 7,
    name: "Henrik Bygum",
    role: "Erhvervsleder",
    text: `Efter mine nu 5 sessioner med Michael, er jeg overbevist! Kommer du med den rette indstilling og er du klar til at åbne op og lade dig udfordre, så har Michael virkeligt noget at byde på.

Jeg kontaktede primært Michael, for at få en sparringspartner ift. at komme på den ”mentalt rette vej”. Har tidligere været HELT nede med stress, og begyndte at kunne genkende nogle symptomer og tegn, som jeg vidste, var usunde for mig, men som jeg ikke magtede selv at kæmpe mig ud af.

Jeg kom til Michael med en vis erfaring og en del værktøjer i bagagen, ikke kun fra mine personlige erfaringer med stress, men også fra mine jobs som erhvervsleder igennem mange år. Ikke desto mindre stod det hurtigt klart, at jeg i Michael i den grad blev udfordret – ikke bare på min viden, men i høj grad også på mine perspektiver. Michael fik allerede fra vores første session, guidet/coachet mig i nogle nye retninger, hvilke øjeblikkeligt gav helt håndgribelige resultater.

På bagkant ligner alt jo sund fornuft, ”stå op 15 min. før end du plejer, tænk over din dag og hvad du vil nå”, læg iPad’en fra dig og afstem med din familie hvilke behov der er omkring dig”, ”Fjern din mobil fra soveværelset” osv. osv. I nogle tilfælde bitte små ting, men som mentalt kan fylde utroligt meget – især når summen af alle de bitte små ting gøres op, er de pludseligt ikke så små og ubetydelige længere.

Jeg kan kun give mine bedste anbefalinger til Michael – han har i den grad hjulpet og flyttet mig! Selvom jeg troede, at jeg vidste det meste.`,
    type: "erhverv"
  },
  {
    id: 8,
    name: "Annette Just",
    role: "Organisationssekretær, 3F Bygningsarbejderne Fyn",
    text: `Vi valgte at booke Michael til individuel ledelsesudvikling, et medlemsarrangement og en temadag for vores medarbejdere.

Vi har således gjort brug af ham på forskellige niveauer, og vi må bare sige at han kan noget, der skaber refleksion og forandring, uanset om det er på ledelsesniveau eller for vores medlemmer.

Michael har et Trivlogi forløb på 5 sessioner, som vi i Daglig Ledelse hver især har været igennem, vi har arbejdet med vores individuelle udfordringer, på en måde der konkret kan omsættes i vores daglige ledelsesarbejde.

Vi har holdt en konference for vores Tillids- og kontaktpersoner med 40 deltagere. Michael deltog med et oplæg på ca. 2 timer, det var ret utroligt at se, hvordan bygningsarbejdere åbnede op og fortalte om bl.a. den hårde tone på arbejdspladsen, og hvad det gjorde ved dem, de fik helt enkle værktøjer til at begynde at ændre på kulturen på byggepladsen. Herudover blev der talt om organisering af kolleger, igen enkle og gode redskaber til at afvæbne fordomme, indgå i en god dialog m.v.

Temadagen for vores medarbejdere gav for alvor Michael mulighed for at udfordre deltagerne, hvilket takket være hans tillidsvækkende facon blev taget godt imod, og åbnede for mange gode refleksioner hos deltagerne.

Michaels måde at være tilstede i rummet sammen med deltagerne, og ikke kun møde dem i det de bragte op, men også få deltagerne til selv at finde nye alternativer, tanker og følelser omkring emner der fyldte hos dem, er noget der for alvor skaber en ændring hos deltagerne.

Der har været rigtig gode tilbagemeldinger fra personalet. Michael omsætter psykologiske teorier, videnskab og egne erfaringer på en meget nærværende, konkret og overskuelig måde.

Han bringer sig selv i spil, og italesætter ”elefanten i rummet”. Han er en meget dygtig formidler.

Vi er rigtig glade for det Michael har bidraget med hos os i daglig ledelse og blandt personale, og han er helt sikkert vores ”go-to” i fremtiden, når vi skal have hjælp udefra til at løse situationer internt.`,
    type: "erhverv"
  },
  {
    id: 9,
    name: "Bahadir Demirhan",
    role: "Indehaver, Ejendomsmægler – Nybolig Odense",
    text: "”Hos Nybolig Odense – Thomsen, Demirhan & Led arbejder vi med mennesker. Om det er en køber eller sælger. Derfor handler det om mennesker, og når det handler om mennesker handler det om følelser. Det betyder at tillid er utrolig vigtig og at forstå de mennesker og udvise empati er en stor del af vores succes. Uanset erfaring, knowhow, så havde vi behov for en ekspert som kunne hjælpe os til at blive skarpere endnu – i den forbindelse fik vi anbefalet Michael, og gudskelov for det! Blot efter få timer var vi klædt på med nye, simple og nemme redskaber til at kunne gøre en forskel for vores kunder – TAK Michael, det er ikke sidste gang vi har set dig! De varmeste anbefalinger fra gruppen – du er en stjerne!”",
    type: "foredrag"
  },
  {
    id: 10,
    name: "Lægerne Jacob Gades Alle",
    role: "Vejen",
    text: `Et godt og tankevækkende foredrag fortalt i et let forståeligt sprog. Budskabet bliver leveret med humor og med mange gode pointer. Brugbar information, som vi kan drage nytte af i hverdagen.
Kan helt klart anbefales.`,
    type: "foredrag"
  },
  {
    id: 11,
    name: "Lene",
    age: "52 år",
    text: `Hele mit liv har været på andres ønsker og præmisser. Jeg var bange for alt hvad der var nyt, fremmed, usikkert og anderledes. Jeg var statist i mit liv og turde ikke sige til og fra.

Men… Så mødte jeg Michael… og der blev talt med store kærlige bogstaver… jeg blev hørt, guidet og set… mine drømme og ønsker var i fokus. Mine begrænsninger var imellem ørerne.

Michael er fantastisk til at skabe de rammer der skal til for at du selv kan gøre en forskel.

Jeg har nu hovedrollen i mit liv… jeg har via hans hjælp flyttet mig fysisk og psykisk fra det der ikke var godt i mit liv.

Michael er skarp og stærk i sit arbejde. Han er ikke en pleaser. Han ser muligheder hvor andre ser begrænsninger og mest af alt ser han DIG.

Kæmpe anbefaling herfra. Endnu engang tak Michael fordi du hjalp mig til et meget bedre liv.`,
    type: "klient"
  },
  {
    id: 12,
    name: "Peter",
    age: "32 år",
    text: `Et forløb ved Michael fik mig ud af mine langvarige stress- og angstsymptomer, som var drevet af mine people pleasing-tendenser.

Jeg havde i mange år, siden jeg trådte ind på arbejdsmarkedet, døjet med stress- og angstsymptomer, som kunne blive trigget af alt lige fra, at en kollega havde en dårlig dag, til at jeg missede en deadline, og min chef blev sur. Jeg var meget konfliktsky og havde svært ved at sige fra og gik meget op i, at andre havde det godt. Dette var ekstremt udmattende, og i mange år hoppede jeg fra job til job.

Under dette havde jeg været ved forskellige psykologer og psykoterapeuter for at komme ud af min arbejdsstress, men det fungerede lidt som at tisse i bukserne. Det hele var bare snak om, hvad der skete på arbejdet her og nu, og der blev aldrig gravet dybere ned i, hvorfor jeg blev ved med at være konfliktsky, have angst og stress.

I Michaels 1 måneds intensive forløb var vi hele paletten rundt. Michael bruger biologi, mindset og strategi som hovedelementerne i hans forløb, hvilket gjorde, at vi startede med at undersøge min biologi. Her snakkede vi søvn, vejrtrækning, kost og om hvordan ens opvækst påvirker ens nervesystem. Michael fandt hurtigt ud af, at grunden til, at jeg havde disse people pleasing-tendenser, var, at jeg havde påtaget mig en rolle som peacekeeper i hjemmet, og at jeg følte mig ansvarlig for at holde roen.

Dette havde været en rolle, som jeg altid har haft, og derfor blev det først et stort problem, da jeg trådte ud på arbejdsmarkedet. Igennem forløbet har Michael hjulpet med at få forløst mange gamle traumer og triggere, der lå i mig, hvilket gjorde det nemmere at arbejde videre mod at sige fra over for venner, familie og kollegaer.

Derudover hjælper Michael også aktivt med ens mindset med at arbejde med ens problemer under forløbet, så man ser resultater. Michael bruger strategier for, at man bliver stærkere som individ, og hans filosofi er at give en værktøjerne og lære en at bruge dem, så man derefter kan selv kan både forstå og mestre de udfordringer der dukker op.

Igennem forløbet har jeg fået forløst mine problemer med mine forældre, lært at sige fra over for venner og kollegaer og står nu stærkere end nogensinde. Jeg kommer aldrig til at være bange for at få langvarig stress igen, da jeg ved, at jeg nu selv har redskaberne og viden til at kunne coache og vejlede mig selv.

Selvom Michaels forløb ofte kun er 1 måned, har jeg gjort brug af nogle ekstra samtaler efterfølgende for at holde mig selv fokuseret på ikke at falde tilbage i de gamle mønstre.

Det, der har været mest mirakuløst ved Michaels forløb, er, at man efterfølgende bliver ved med at opdage nye ting om sig selv, og at man ved hjælp af de værktøjer, man har fået tillært, bliver ved med at arbejde videre med sine problemer på egen hånd.`,
    type: "klient"
  }
];

export const services = [
  {
    id: "trivlogi-1-1",
    title: "Trivlogi® 1-1 Forløb",
    fullDescription: "Vores sessioner vil bestå af både coaching, men også undervisning og rådgivning. Ret ofte vil vores forløb primært starte med rådgivning, da coachingens redskaber ikke har så god effekt, når man er ramt af f.eks. stress, angst eller depression.",
    image: "/materiale-260501/image00001.jpg",
    structureImage: "/materiale-260428/Bio-mind-strat_gron2.svg",
    questions: [
      "Føler du dig stresset eller udbrændt?",
      "Oplever du angst eller uro i hverdagen?",
      "Har du svært ved at sige fra og sætte grænser?",
      "Mangler du overskud og glæde i dit liv?"
    ],
    features: [
      "5 sessioner af 60-90 minutters varighed",
      "Fri sparring 24/7 over telefon og SMS under hele forløbet",
      "Personlige værktøjer til biologisk ro og mentalt overskud",
      "Gennemgang af dine biologiske reaktionsmønstre"
    ],
    duration: "5 sessioner á 60-90 min",
    location: "Kolding, Online eller på anden lokation efter aftale",
    price: "4.500 kr for de 5 sessioner",
    additionalInfo: "Forløbet vil blive fuldstændig tilpasset dig, hvordan du har det og hvad dine behov er. Betaling kan deles op efter aftale"
  },
  {
    id: "konflikten",
    title: "Konflikthåndtering",
    fullDescription: "Jeg har en dyb passion for at hjælpe både private og fællesskaber med at forstå deres 'interne regler' og tillærte adfærd. Ved at kigge bagom vores reaktioner kan vi skabe fundamentale ændringer, der holder.",
    image: "/materiale-260428/3-Kasse_alle_2.png",
    topics: [
      "Forståelse af de biologiske reaktioner i en konflikt",
      "Kommunikation der afvæbner fremfor at optrappe",
      "Adfærd og mønstre bag vores reaktioner",
      "Værktøjer til at skabe ro og dialog"
    ],
    benefits: [
      "Færre konflikter",
      "Bedre kommunikation",
      "Større gensidig respekt",
      "Psykologisk tryghed"
    ],
    moodImage: "/materiale-260501/image00010.jpg"
  },
  {
    id: "trivsel-i-faellesskabet",
    title: "Trivsel i fællesskabet",
    fullDescription: "Målet er at den enkelte står stærkere og trives i det fællesskab, der er hverdagen. Dette kan leveres i flere formater alt efter jeres behov.",
    image: "/materiale-260428/3-Kasse_alle_2.png",
    moodImage: "/materiale-260501/image00010.jpg",
    formats: [
      {
        title: "Foredrag (1-2 timer)",
        description: "Deltagerne bliver inddraget via spørgsmål og små øvelser med sidemanden. Fokus på inspiration og bevidsthed."
      },
      {
        title: "Workshop (3-4 timer)",
        description: "Deltagerne bliver mere inddraget med dybdegående opgaver. Vi udfordrer holdninger og påstande udenfor komfortzonen."
      },
      {
        title: "Temadag (6-8 timer)",
        description: "Vi går for alvor i dybden. Deltagerne får en skræddersyet personlig værktøjskasse med hjem."
      }
    ],
    benefits: [
      "Stærkere sammenhold",
      "Fælles sprog for trivsel",
      "Værktøjer til stressforebyggelse",
      "Øget arbejdsglæde"
    ]
  },
  {
    id: "ledelsesudvikling",
    title: "Ledelsesudvikling",
    fullDescription: "Styrk ledelsen og virksomheden med fokus på de to vigtigste søjler: Kommunikation og relationer. Gennem en dyb forståelse for menneskelig biologi og trivsel, ruster vi ledere til at skabe balance – både hos sig selv og i de fællesskaber, de har ansvaret for.",
    image: "/materiale-260501/image00003.jpg",
    structureImage: "/materiale-260428/Bio-mind-strat_gron2.svg",
    structureTitle: "BIOLOGI – MINDSET – STRATEGI",
    structureDescription: "TRIVLOGI® er fundamentet i forløbet. Vi arbejder med biologien bag trivsel for at forstå, hvorfor vores system reagerer, som det gør. Ved at kombinere den biologiske forståelse med et stærkt mindset og konkrete strategier, skaber vi ledere, der kan navigere autentisk og bevare roen – selv i pressede situationer.",
    introText: "Før du kan lede andre, må du kunne lede dig selv. Forløbet tager afsæt i, hvordan vores interne balance og trivsel direkte påvirker vores evne til at kommunikere og skabe sunde relationer i et team.",
    topics: [
      "TRIVLOGI®: Biologi – Mindset – Strategi",
      "Kommunikation og relationer med os selv og andre",
      "Kropssprog og holdning: Hvordan du påvirker dig selv og dit team",
      "Stress og pres: Forstå biologien bag og find vejen tilbage til balance",
      "Konflikternes oprindelse: Hvad trigger dig og dine medarbejdere?",
      "Når tillid og respekt er ramt: Vejen tilbage til samarbejdet",
      "Dit ansvar for egen tilstand som leder",
      "Menneskets primitive behov for fællesskab og din rolle heri",
      "Coachende, motiverende og autentisk kommunikation",
      "At navigere i rollen som leder VS kollega",
      "Kunsten at lytte: Grundstenen i effektiv ledelse"
    ],
    benefits: [
      "Stærkere personligt lederskab",
      "Evnen til at skabe ro i pressede situationer",
      "Bedre konflikthåndtering og team-balance",
      "Forståelse for biologiske trivselsmekanismer",
      "Konkrete værktøjer til daglig ledelse"
    ],
    moodImage: "/materiale-260501/image00009.jpg"
  }
];

export const formats = [
  {
    id: "foredrag",
    title: "Foredrag",
    duration: "1-2 timer",
    description: "I mine foredrag vil deltagerne blive inddraget i form af spørgsmål fra mig til dem, og de kan blive bedt om at drøfte noget, eller lave en lille øvelse med sidemanden. Derudover er det mig der snakker og gennemgår foredragets tema."
  },
  {
    id: "workshop",
    title: "Workshop",
    duration: "3-4 timer",
    description: "Mine workshops er meget baseret på deltagerne. Her bliver de mere inddraget og de vil få mere dybdegående opgaver. Fordelen ved at have længere tid med deltagerne er, at jeg bedre kan udfordre deres holdninger, følelser og påstande. Nye tanker og løsninger ligger udenfor vores komfortzone, og det er præcis dér vi kan nå ud på en workshop."
  },
  {
    id: "temadag",
    title: "Temadag",
    duration: "6-8 timer",
    description: "Her er der tid og plads til at for alvor at kunne gå i dybden. Her vil deltagerne komme hjem med en skræddersyet og personlig værktøjskasse. Når tid og tillid mødes, åbner folk ofte op for selv de dybeste tanker og udfordringer, og lige dér ligger alle muligheder for personlig vækst, udvikling og balance."
  }
];

export const profile = {
  name: "Michael Lunde",
  image: "/materiale-260501/portræt/image00011.jpg",
  title: "Livsstils & Erhvervscoach | StressMentor",
  certifications: [
    "Uddannet & Certificeret Livsstils og Erhvervscoach hos Sofia Manning - 2016",
    "Uddannet & Certificeret StressMentor hos StressMentor.nu - 2018",
    "Har siden 2018 studeret biologiske vilkår for menneskelig trivsel og bevæggrunde bag vores adfærd og kommunikationstil."
  ],
  bio: "Jeg arbejder ud fra grundholdningen 'Dit liv - dit ansvar'. Som uddannet coach og stressmentor hjælper jeg mennesker med at genvinde kontrollen over deres liv, forstå deres biologiske reaktioner på stress og skabe varig forandring gennem bevidsthed og handling."
};
